import React from 'react';
import { Layout } from 'antd';
import MemberSidebar from './MemberSidebar';
import { APPBACKGROUND_COLOR } from '../appsettings';
import { Outlet } from 'react-router-dom';

const { Content } = Layout;

const MemberLayout = ({ children }) => {
    return (
        <Layout style={{ minHeight: '100vh', background: APPBACKGROUND_COLOR }}>
            <MemberSidebar />
            <Layout style={{ 
                background: 'transparent',
                transition: 'all 0.3s',
                marginLeft: 0, // Managed via responsive CSS or Layout logic
            }}>
                <Content style={{ 
                    padding: 'clamp(16px, 4vw, 32px)', 
                    marginTop: 64, // Space for mobile header
                    marginLeft: 0,
                    transition: 'margin 0.3s'
                }}>
                    <div style={{ maxWidth: 1200, margin: '0 auto', width: '100%' }}>
                        <Outlet />
                    </div>
                </Content>
            </Layout>

            {/* Layout adjustments for Desktop Sider */}
            <style>{`
                @media (min-width: 992px) {
                    .ant-layout-content { 
                        margin-left: var(--sider-width, 260px) !important; 
                        margin-top: 0 !important;
                    }
                    /* When collapsed, adjust margin */
                    .ant-layout-sider-collapsed + .ant-layout {
                        margin-left: 80px !important;
                    }
                    .ant-layout-sider:not(.ant-layout-sider-collapsed) + .ant-layout {
                        margin-left: 260px !important;
                    }
                }
            `}</style>
        </Layout>
    );
};

export default MemberLayout;
